import MyApplication from "../common/core/MyApplication";
import MathUtil from "../common/util/MathUtil";

class Graph {
  // ---------------------------------------------------------------------------------------------------------
  // --	Graph
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    //アプリケーション生成
    this.app = MyApplication.getMyApp();

    //中心点
    this.center = new PIXI.Point(282, 297);

    //グラフ配置
    this.graph = new PIXI.Graphics();
    this.app.stage.addChild(this.graph);

    //初期アップデート
    this.update([0, 0, 0, 0, 0]);
  }

  /**
   * 表示更新
   */
  update(scores) {
    this.graph.clear();
    this.graph.beginFill(0xf1f334);
    const rotUnit = 360 / scores.length;
    for (let i = 0; i < scores.length; i++) {
      const score = scores[i];
      const distance = score === 0 ? 0 : 8 + 274 * (score / 20);
      const radian = MathUtil.degreeToRadian(-90 + rotUnit * i);
      const x = this.center.x + Math.cos(radian) * distance;
      const y = this.center.y + Math.sin(radian) * distance;
      if (i == 0) {
        this.graph.moveTo(x, y);
      } else {
        this.graph.lineTo(x, y);
      }
    }
    this.graph.closePath();
    this.graph.endFill();
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	Graph
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ランダムな動き
   */
  startRandomMove() {
    //変数初期化
    this.score1 = 0;
    this.score2 = 0;
    this.score3 = 0;
    this.score4 = 0;
    this.score5 = 0;

    //ランダムな動きスタート
    this.randomMove();
  }

  randomMove() {
    gsap.to(this, 1, {
      score1: 1 + Math.floor(Math.random() * 19),
      score2: 1 + Math.floor(Math.random() * 19),
      score3: 1 + Math.floor(Math.random() * 19),
      score4: 1 + Math.floor(Math.random() * 19),
      score5: 1 + Math.floor(Math.random() * 19),
      ease: "power2.inOut",
      onUpdate: () => {
        this.update([
          this.score1,
          this.score2,
          this.score3,
          this.score4,
          this.score5,
        ]);
      },
      onComplete: () => {
        gsap.delayedCall(1, this.randomMove.bind(this));
      },
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Graph;
